import * as React from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

import { Box, IconButton, Card,CardMedia, Link} from '@mui/material';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Carousel from 'react-material-ui-carousel'
import { useNavigate } from 'react-router-dom';
import { Pause, PlayArrow, ArrowBackIos, ArrowForwardIos } from '@mui/icons-material';
import CardSignUp from 'views/signup/components/CardSignUp';

export default function Banners({banners=[], height='100vh', card=true, rights=true}) {
  
  const [autoPlay, setAutoPlay] = React.useState(true);

  const dotColor = '#ffffff';

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        height: height, // Full screen height
      }}
    >
      <Carousel
        autoPlay={autoPlay}
        interval={4000}
        fullHeightHover
        animation="slide"
        navButtonsAlwaysVisible
        indicators={false}
        indicatorContainerProps={{
          style: {
            position: 'absolute',
            bottom: 20,
            zIndex: 2,
            textAlign: 'center',
            width: '100%',
          },
        }}
        indicatorIconButtonProps={{
          style: {
            fontSize: '8px',
            color: 'rgba(189, 189, 189, 0.4)',
          },
        }}
        activeIndicatorIconButtonProps={{
          style: { color: dotColor },
        }}
        navButtonsProps={{
          style: {
            backgroundColor: 'transparent',
            color: dotColor,
          },
        }}
        PrevIcon={<ArrowBackIos fontSize="small" />}
        NextIcon={<ArrowForwardIos fontSize="small" />}
      >
        {banners?.map((item) => (
          <Card key={item.id} sx={{ position: "relative", height: "100%" }}>
            <CardMedia
              component="img"
              image={item.image_url}
              alt={item.title}
              sx={{
                height: height,
                width: "100%",
                objectFit: "cover",
              }}
            />

            {/* Overlay for this slide */}
            {card?<Stack
              direction={"row"}
              spacing={2}
              alignItems="flex-start"
              sx={{
                position: "absolute",
                top: "50%",
                left: { xs: 24, md: 64 },
                transform: "translateY(-50%)",
                zIndex: 3,
                width: { xs: "80%", md: "65%" },
                padding: { xs: 1, md: 2 },
                textAlign: "left",
                background: item.background,
                
              }}
            >
              {/* Card - 65% */}
              <Box sx={{ flex: { xs: "1 1 100%", md: "0 0 60%" } }}>
                <CardSignUp darkMode={true}/>
              </Box>

              {/* Texto - 35% */}
              <Box sx={{ flex: { xs: "1 1 100%", md: "0 0 40%" } }}>
                <Stack>
                  <Typography variant="h2" sx={{ mb: 2, color: item.color }}>
                    {item.title}
                  </Typography>
                  <Typography variant="h6" sx={{ mb: 3, color: item.color }}>
                    {item.subtitle}
                  </Typography>
                  {item.action && (
                    <Link variant="text" sx={{ textTransform: "none", fontWeight: "bold", color:"white" }}>
                      {item.action}
                    </Link>
                  )}
                </Stack>
              </Box>
            </Stack>:<></>}

                
            {/* Overlay for this slide */}
            {rights?<Stack
              alignItems="flex-start"
              sx={{
                position: "absolute",
                bottom: "5%", 
                left: { xs: 24, md: 64 },
                transform: "translateY(50%)",
                zIndex: 3,
                width: { xs: "80%", md: "50%" },
                padding: { xs: 1, md: 2 },
                textAlign: "left",
              }}
            >
              <Link variant="body" sx={{ mb: 3, fontWeight:'bolder', color: '#F4136B' }}>
                 All rights reserved © FAMBI 2025 →
              </Link>
            </Stack>
            :<></>}
          </Card>
        ))}
      </Carousel>
      {/* Play / Pause */}
      <IconButton
        onClick={() => setAutoPlay(!autoPlay)}
        sx={{
          position: 'absolute',
          bottom: 20,
          right: 20,
          zIndex: 3,
          backgroundColor: 'rgba(0,0,0,0.3)',
          color: dotColor,
          '&:hover': { backgroundColor: 'rgba(0,0,0,0.5)' },
        }}
      >
        {autoPlay ? <Pause /> : <PlayArrow />}
      </IconButton>
    </Box>
  );
}